import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_5 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_6 = { class: "dropdown-item" }
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { class: "table table-bordered table-hover" }
const _hoisted_9 = { class: "dropdown" }
const _hoisted_10 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_11 = { class: "dropdown-item" }
const _hoisted_12 = ["disabled", "onClick"]

import { onMounted, watch, computed, ref, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import CorporateNavigation from "@common/Components/CorporateNavigation.vue"

    import { usePnlsPageQueryV1 } from '@Quest/Pnls/queries-vue-composables'
    import { useDeletePnlCommandV1 } from '@Quest/Pnls/commands-vue-composables'

    import type { PnlsPageReadModel } from '@Quest/Pnls/readmodels'


    /* ---------------- route params ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PnlsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))


    /* ---------------- query ---------------- */

    const {
        runPnlsPageQueryV1,
        modelPnlsPageQueryV1
    } = usePnlsPageQueryV1(workspaceId, strategyId)

    const rm = modelPnlsPageQueryV1 as Ref<PnlsPageReadModel | null>
    const pnlIdToDelete = ref<string | null>(null)


    /* ---------------- command ---------------- */

    const {
        invokeDeletePnlCommandV1,
        succeedDeletePnlCommandV1,
        invokingDeletePnlCommandV1
    } = useDeletePnlCommandV1(workspaceId, strategyId, pnlIdToDelete)


    /* ---------------- lifecycle ---------------- */

    onMounted(() =>
    {
        document.title = "P&L templates | TransparentChoice"
        runPnlsPageQueryV1()
    })


    /* ---------------- actions ---------------- */

    function handleDeletePnlCommand(pnlId: string)
    {
        if (invokingDeletePnlCommandV1.value) return

        if (confirm("Are you sure?") === true)
        {
            pnlIdToDelete.value = pnlId;
            invokeDeletePnlCommandV1()
        }
    }


    /* ---------------- command success handling ---------------- */

    watch(succeedDeletePnlCommandV1, (current, previous) =>
    {
        if (current && !previous && rm.value)
        {
            const id = pnlIdToDelete.value
            if (!id) return

            rm.value.Corporate = rm.value.Corporate.filter(a => a.Id !== id)
            pnlIdToDelete.value = null
        }
    })

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CorporateNavigation, { ActivePage: "strategy" }),
    (_unref(rm))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-6" }, [
              _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "P&L templates")
            ], -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_3, [
              (_unref(rm).Defaults)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _cache[2] || (_cache[2] = _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-success dropdown-toggle",
                      "data-toggle": "dropdown",
                      style: {"padding":"0.7em 2em"}
                    }, "Create P&L", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_5, [
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                        _createTextVNode(" Blank ", -1 /* CACHED */)
                      ]))])), [
                        [_directive_sanitizedHref, `/#/enterprise/pnls/create/${workspaceId.value}/${strategyId.value}`]
                      ]),
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Defaults, (t) => {
                        return _withDirectives((_openBlock(), _createElementBlock("a", {
                          class: "dropdown-item",
                          key: t.Id
                        }, [
                          _createTextVNode(_toDisplayString(t.Name), 1 /* TEXT */)
                        ])), [
                          [_directive_sanitizedHref, `/#/enterprise/pnls/create/${workspaceId.value}/${strategyId.value}/${t.Id}`]
                        ])
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th"),
                  _createElementVNode("th", { style: {"width":"120px"} })
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Corporate, (t) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: t.Id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(t.Name), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[5] || (_cache[5] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_11, [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("Edit", -1 /* CACHED */)
                          ]))])), [
                            [_directive_sanitizedHref, `/#/enterprise/pnls/edit/${workspaceId.value}/${strategyId.value}/${t.Id}`]
                          ]),
                          _createElementVNode("button", {
                            class: "dropdown-item",
                            disabled: _unref(invokingDeletePnlCommandV1),
                            onClick: ($event: any) => (handleDeletePnlCommand(t.Id))
                          }, "Delete", 8 /* PROPS */, _hoisted_12)
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})